module.exports = __webpack_public_path__ + "static/media/Timburr_gaussian2.43be8784.png";